import { PointerWithRecord } from "libs/schema";
import { IListOnEntryActionEvent, IListRef } from "~/components/list";
import { ClientEnvironment } from "~/environment/ClientEnvironment";
import { isModKeyActive } from "~/environment/command.service";
import { UnreachableCaseError } from "libs/errors";
import { useMemo } from "react";
import { IThreadViewContext } from "../thread/context";

export type TScheduledEntry = PointerWithRecord<"message">;

/* -----------------------------------------------------------------------------------------------*/

export async function onScheduledEntrySelect(
  environment: Pick<ClientEnvironment, "router">,
  props: {
    event: IListOnEntryActionEvent<TScheduledEntry>;
  },
) {
  const { event } = props;

  switch (event.entry.table) {
    case "message": {
      return environment.router.navigate(`/scheduled/threads/${event.entry.record.thread_id}`, {
        openInNewTab: isModKeyActive(event.event),
      });
    }
    default: {
      throw new UnreachableCaseError(event.entry.table);
    }
  }
}

/* -----------------------------------------------------------------------------------------------*/

export function useScheduledViewThreadContext(props: { listRef: React.RefObject<IListRef<TScheduledEntry>> }) {
  const { listRef } = props;

  return useMemo((): IThreadViewContext => {
    return { threadList: { type: "scheduled", ref: listRef } };
  }, [listRef]);
}

/* -----------------------------------------------------------------------------------------------*/
